import {
	Stack,
	Label,
	TextField,
	Callout,
	DirectionalHint,
	Calendar,
	Separator,
	DefaultButton,
	StackItem,
} from '@fluentui/react';
import React, { createRef } from 'react';
import { IUserConfigPackage } from '../../API';

export interface IDatePickerNullableProps {
	value: Date | null;
	readOnly?: boolean;
	minDate?: Date;
	maxDate?: Date;
	label?: string;
	placeholder?: string;
	userConfig: IUserConfigPackage;
	onSelectDate: (val: Date | null) => void;
}

interface IDatePickerNullableState {
	selectedDate: Date | undefined;
	showCallout: boolean;
}

export default class DatePickerNullable extends React.Component<
	IDatePickerNullableProps,
	IDatePickerNullableState
> {
	private textFieldRef = createRef<HTMLDivElement>();

	constructor(props: IDatePickerNullableProps) {
		super(props);
		this.state = {
			selectedDate: props.value || undefined,
			showCallout: false,
		};
	}

	componentDidUpdate(prevProps: IDatePickerNullableProps) {
		if (prevProps.value !== this.props.value) {
			this.setState({
				selectedDate: this.props.value || undefined,
			});
		}
	}

	render() {
		let selectDate = (date: Date | null) => {
			this.setState({
				selectedDate: date || undefined,
				showCallout: false,
			});

			this.props.onSelectDate(date);
		};

		let minDate = this.props.minDate ? new Date(this.props.minDate) : undefined;
		let maxDate = this.props.maxDate ? new Date(this.props.maxDate) : undefined;

		return (
			<Stack>
				{this.props.label === '' ? (
					<></>
				) : (
					<Label>{this.props.label || 'Date'}</Label>
				)}
				<div ref={this.textFieldRef}>
					<TextField
						placeholder={this.props.placeholder}
						style={{ cursor: 'pointer' }}
						iconProps={{ iconName: 'Calendar' }}
						readOnly={true}
						onClick={() => {
							this.setState({ showCallout: !this.state.showCallout });
						}}
						value={this.state.selectedDate?.toDateString()}
					></TextField>
				</div>

				{this.state.showCallout ? (
					<Callout
						role="dialog"
						gapSpace={0}
						target={this.textFieldRef}
						isBeakVisible={false}
						directionalHint={DirectionalHint.bottomLeftEdge}
						onDismiss={() => this.setState({ showCallout: false })}
					>
						<Stack>
							<Calendar
								showGoToToday
								onSelectDate={(d) => selectDate(d)}
								minDate={minDate}
								maxDate={maxDate}
								value={this.state.selectedDate}
							/>
							<Separator />
							<Stack horizontal style={{ padding: 5 }}>
								<StackItem>
									<DefaultButton
										disabled={!this.state.selectedDate}
										onClick={() => {
											selectDate(null);
										}}
									>
										Clear date
									</DefaultButton>
								</StackItem>

								<StackItem grow>&nbsp;</StackItem>
							</Stack>
						</Stack>
					</Callout>
				) : (
					<></>
				)}
			</Stack>
		);
	}
}
